export function getPlatform() {
  if (window.Capacitor?.isNativePlatform?.()) {
    return window.Capacitor.getPlatform() || 'web';
  }
  return 'web';
}

export function isNative() {
  return getPlatform() !== 'web';
}

export function isIOS() {
  return getPlatform() === 'ios';
}

// Stripe has been removed — Apple IAP (iOS) is the only payment path.
// Non-native platforms have no in-app checkout; upgrades happen in the iOS app.
export function getPaymentPlatform() {
  const platform = getPlatform();
  if (platform === 'ios') return 'apple';
  if (platform === 'android') return 'google';
  return 'web';
}
